package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.state.AppState
import io.horion.cv.styles.BillingInfoStyle
import io.horion.cv.styles.PriceRowStyle
import io.horion.cv.styles.PriceSubtextStyle
import io.horion.cv.styles.PriceTextStyle
import io.horion.cv.styles.PricingCardContainerStyle
import io.horion.cv.styles.SubscribeButtonStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun PricingCard(
    price: String,
    priceSubtext: String,
    billingInfo: String,
    features: List<String>,
    modifier: Modifier = Modifier
) {
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val cardBg       = if (isDark) Colors.holder    else Colors.PriceGray
    val priceColor   = if (isDark) Colors.White     else Colors.DarkBlue
    val subtextColor = if (isDark) Colors.LightGray else Colors.Graytext

    Column(
        modifier = PricingCardContainerStyle.toModifier()
            .then(modifier)
            .backgroundColor(cardBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .borderRadius(32.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SpanText(
            text = billingInfo,
            modifier = BillingInfoStyle.toModifier()
                .fontSize(14.px)
                .fontFamily(INTER)
                .fontWeight(FontWeight.Normal)
                .color(Colors.Lightblue)
        )

        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = PriceRowStyle.toModifier()
        ) {
            P(
                attrs = PriceTextStyle.toModifier()
                    .fontWeight(FontWeight.Bold)
                    .fontFamily(INTER)
                    .color(priceColor)
                    .toAttrs()
            ) {
                Text(price)
            }

            P(
                attrs = PriceSubtextStyle.toModifier()
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Normal)
                    .color(subtextColor)
                    .margin(left = 8.px)
                    .whiteSpace(WhiteSpace.PreWrap)
                    .toAttrs()
            ) {
                Text(priceSubtext)
            }
        }

//        Button(
//            onClick = {
//                ctx.router.navigateTo("/payment")
//            },
//            modifier = SubscribeButtonStyle.toModifier()
//                .fillMaxWidth()
//                .height(buttonHeight)
//                .fontFamily(INTER)
//                .fontSize(buttonFontSize)
//                .fontWeight(FontWeight.Medium)
//                .borderRadius(30.px)
//                .margin(bottom = if (isMobile) 40.px else 60.px)
//                .color(Colors.White),
//        ) {
//            Text("Payer")
//        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .gap(16.px),
            horizontalAlignment = Alignment.Start
        ) {
            features.forEach {
                FeautureItem(it)
            }
        }
    }
}
